import { render, staticRenderFns } from "./InsufficientPermission.vue?vue&type=template&id=030e4d8a&scoped=true"
import script from "./InsufficientPermission.vue?vue&type=script&lang=js"
export * from "./InsufficientPermission.vue?vue&type=script&lang=js"
import style0 from "./InsufficientPermission.vue?vue&type=style&index=0&id=030e4d8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030e4d8a",
  null
  
)

export default component.exports